export function getSiteBasePath(pathname) {
  const currentPath =
    pathname || (typeof window !== 'undefined' ? window.location.pathname : '/')

  if (currentPath.startsWith('/official_website/') || currentPath === '/official_website') {
    return '/official_website/'
  }

  return '/'
}
